// extracted by mini-css-extract-plugin
module.exports = {"kalkulatoromrade":"KalkulatorField_kalkulatoromrade__hdm_4"};